import { render, staticRenderFns } from "./truck-summary-modal.vue?vue&type=template&id=c435e0f2&scoped=true&"
import script from "./truck-summary-modal.component.ts?vue&type=script&lang=ts&"
export * from "./truck-summary-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./truck-summary-modal.scss?vue&type=style&index=0&id=c435e0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c435e0f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c435e0f2')) {
      api.createRecord('c435e0f2', component.options)
    } else {
      api.reload('c435e0f2', component.options)
    }
    module.hot.accept("./truck-summary-modal.vue?vue&type=template&id=c435e0f2&scoped=true&", function () {
      api.rerender('c435e0f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/truck-summary-modal/truck-summary-modal.vue"
export default component.exports